import { Card } from './CardProps';
import SessionCard from './SessionCard';

interface Props {
  cards: Card[];
  onCardClick: (sessionUid: string) => any;
}

const SessionCards: React.FC<Props> = ({ cards, onCardClick }) => {
  return (
    <>
      {cards.map((card, i) => (
        <SessionCard key={card.sessionUid} card={card} onCardClick={onCardClick} delay={100 + i * 40} />
      ))}
    </>
  );
};

export default SessionCards;
